import { Component, OnInit } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {LoginParamModel} from '../model';
import {AuthenticationService} from '../service';
import { constants } from '../app-constants';
import {UsuarioLogadoModel} from '../model';
import { CookieService } from 'ngx-cookie-service';
import {AdvGrowlService} from 'primeng-advanced-growl';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { PropertiesLocales } from '../util/properties-locale';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {

  loginParam = new LoginParamModel();
  public properties: PropertiesLocales = new PropertiesLocales();
  public message: any;
  login: string;
  msgLogon: string;
  cookieValue: any;
  public basePath: string;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              private cookieService: CookieService,
              private advGrowlService: AdvGrowlService,
              private loadingBar: NgxUiLoaderService,
              private pathLocationStrategy: PathLocationStrategy) { }

  ngOnInit() {
    this.basePath = this.pathLocationStrategy.getBaseHref();
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7).replace('/', '').toString();

    if (!local.match(uri)) { // prevalece o locale definido na URL
      local = uri.replace('/', '');
    }

    switch (local) {
      case 'es':
       this.message = this.properties.items_steps_es;
      break;
      case 'en':
      this.message = this.properties.items_steps_en;
      break;
      default:
      this.message = this.properties.items_steps_pt;
      break;
    }

    this.route.queryParams.subscribe(params => {
      if (params.idEmpresa !== undefined) {
        this.loginParam.idEmpresa = params['idEmpresa'];
        this.cookieService.set( 'idEmpresa', this.loginParam.idEmpresa );
        localStorage.setItem('idEmpresa', this.loginParam.idEmpresa);
        this.cookieValue = this.loginParam.idEmpresa;
      } else {
        const usuarioLogadoModel: UsuarioLogadoModel = JSON.parse( localStorage.getItem(constants.usuarioLogadoKey) );
        if (usuarioLogadoModel != null) {
          this.loginParam.idEmpresa = usuarioLogadoModel.idEmpresa;
          this.cookieValue = this.loginParam.idEmpresa;
        } else {
          this.loginParam.idEmpresa = this.cookieService.get('idEmpresa');
          if (!this.loginParam.idEmpresa) {
            this.loginParam.idEmpresa = localStorage.getItem('idEmpresa');
          }
          this.cookieValue = this.loginParam.idEmpresa;
        }
      }
    });
  }

  public doLogin() {
    if (!this.loginParam.idEmpresa) {
      this.loginParam.idEmpresa = this.cookieService.get('idEmpresa');
      if (!this.loginParam.idEmpresa) {
        this.loginParam.idEmpresa = localStorage.getItem('idEmpresa');
      }
      if (!this.loginParam.idEmpresa) {
        this.msgLogon = this.message[12].msg_service_error_empresaid;
        this.advGrowlService.createTimedErrorMessage(this.message[12].msg_service_error_empresaid, '', 2000);
        return;
      }
    }
    this.loginParam.api = 'PortalCliente';
    this.loginParam.cpf = this.login;

    if ( (this.loginParam.senha == null || this.loginParam.senha === '') || (this.loginParam.cpf == null || this.loginParam.cpf === '')) {
      this.advGrowlService.createTimedErrorMessage(this.message[18].msg_service_error_login_fields, '', 2000);
      return;
    }
    this.loadingBar.start();
    this.authenticationService.login(this.loginParam);
   }

}



